import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCapturedTextDeleted.meta';

export type UseTrackCapturedTextDeletedParams = {
  text_id: string;
  text: string;
};

export const useTrackCapturedTextDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackCapturedTextDeleted = useCallback(
    (params: UseTrackCapturedTextDeletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCapturedTextDeleted };
};
